import React, { useState, useEffect } from "react";
import {
  MdLayers,
  MdFilterList,
  MdCenterFocusStrong,
  MdBrokenImage,
  MdDateRange,
} from "react-icons/md";
import Filters from "./filters";
import Datasets from "./datasets";

import {
  Box,
  Text,
  Flex,
  Collapse,
  useDisclosure,
  Accordion,
  AccordionItem,
  SimpleGrid,
  PopoverTrigger,
  Tooltip,
} from "@chakra-ui/react";
import { useToggle } from "react-use";
import { helperInfo } from "@uidaholib/shared/models/ui/ui";
import { observer } from "mobx-react-lite";

const Layers = observer(() => {
  return (
    <>
      <Flex
        bg="white"
        flexDir="column"
        boxShadow="sm"
        borderRadius="lg"
        flex="1"
      >
        <Accordion allowMultiple allowToggle defaultIndex={[0, 1]}>
          <AccordionItem bg="gray.300">
            <Box>
              <Tooltip
                label="Filter the layers"
                hasArrow
                zIndex={70}
                placement="right"
                isOpen={helperInfo.isOpen}
              >
                <Box>
                  <Filters />
                </Box>
              </Tooltip>
            </Box>
          </AccordionItem>

          <AccordionItem maxH="100%" h="100%">
            <Box>
              <Tooltip
                label="Use the buttons to display layers on the map"
                hasArrow
                zIndex={70}
                placement="right-start"
                isOpen={helperInfo.isOpen}
              >
                <Box>
                  <Datasets />
                </Box>
              </Tooltip>
            </Box>
          </AccordionItem>
        </Accordion>
      </Flex>
    </>
  );
});

export default Layers;
